import { makeStyles } from '@mui/styles';
import theme from 'src/style-system/theme';

export const useStyles = makeStyles({
  autoPlayerWrapper: {
    width: '100%',
  },

  playerWrapper: {
    width: '100%',
    height: '100%',
  },
});
